import type { MisconceptionDefinition } from '../types';
export const nlWaterMisconceptions: MisconceptionDefinition[] = [{
  id: 'topo.water-rijn-als-zuid',
  label: 'Plaatst Rijn in zuiden',
  module: 'Topo',
  description: 'Leerling plaatst de Rijn in het zuiden van Nederland in plaats van het midden.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-waal-met-maas-verward',
  label: 'Verwart Waal met Maas',
  module: 'Topo',
  description: 'Leerling verwart de Waal met de Maas.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-ijssel-met-maas-verward',
  label: 'Verwart IJssel met Maas',
  module: 'Topo',
  description: 'Leerling verwart de IJssel met de Maas.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-ijssel-tak-met-rijn-verward',
  label: 'Verwart IJssel-tak met Rijn',
  module: 'Topo',
  description: 'Leerling verwart de IJssel-tak met de Rijn als geheel.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-waddenzee-als-uitmonding',
  label: 'Plaatst uitmonding in Waddenzee',
  module: 'Topo',
  description: 'Leerling denkt dat een rivier in de Waddenzee uitmondt in plaats van de Noordzee.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-middellandse-zee-misplaatst',
  label: 'Plaatst rivier in Middellandse Zee',
  module: 'Topo',
  description: 'Leerling plaatst een Nederlandse rivier in de Middellandse Zee.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-maas-in-gelderland',
  label: 'Plaatst Maas in Gelderland',
  module: 'Topo',
  description: 'Leerling plaatst de Maas in Gelderland in plaats van Limburg/Brabant.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-schelde-in-midden',
  label: 'Plaatst Schelde in midden-NL',
  module: 'Topo',
  description: 'Leerling plaatst de Schelde in midden-Nederland in plaats van het zuidwesten.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-eems-als-gelderland',
  label: 'Plaatst Eems in Gelderland',
  module: 'Topo',
  description: 'Leerling plaatst de Eems in Gelderland in plaats van Groningen.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-markermeer-met-ijsselmeer-verward',
  label: 'Verwart Markermeer met IJsselmeer',
  module: 'Topo',
  description: 'Leerling verwart het Markermeer met het grotere IJsselmeer.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-waddenzee-als-zuiderzee',
  label: 'Verwart Waddenzee met Zuiderzee',
  module: 'Topo',
  description: 'Leerling verwart de Waddenzee met de voormalige Zuiderzee.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-veluwemeer-met-ijsselmeer-verward',
  label: 'Verwart Veluwemeer met IJsselmeer',
  module: 'Topo',
  description: 'Leerling verwart het Veluwemeer met het IJsselmeer.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-maas-als-duitse-grens',
  label: 'Verwart Maas met Duitse grens',
  module: 'Topo',
  description: 'Leerling denkt dat de Maas de grens met Duitsland vormt.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-waal-als-grens',
  label: 'Denkt Waal vormt grens',
  module: 'Topo',
  description: 'Leerling denkt dat de Waal een landsgrens vormt.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-lek-als-grens',
  label: 'Denkt Lek vormt grens',
  module: 'Topo',
  description: 'Leerling denkt dat de Lek een landsgrens vormt.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-maas-naar-zeeland',
  label: 'Stuurt Maas direct naar Zeeland',
  module: 'Topo',
  description: 'Leerling stuurt de Maas direct naar Zeeland zonder door Brabant te gaan.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-maas-start-zuid-holland',
  label: 'Slaat Brabant over bij Maas',
  module: 'Topo',
  description: 'Leerling denkt dat de Maas direct in Zuid-Holland begint.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-maas-in-nijmegen',
  label: 'Plaatst Maas in Nijmegen',
  module: 'Topo',
  description: 'Leerling plaatst de Maas in Nijmegen in plaats van de Waal.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-rijn-tak-naam-gemist',
  label: 'Noemt Rijn i.p.v. specifieke tak',
  module: 'Topo',
  description: 'Leerling noemt de Rijn in plaats van de specifieke tak (bijv. Waal of IJssel).',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-ijssel-in-nijmegen',
  label: 'Plaatst IJssel in Nijmegen',
  module: 'Topo',
  description: 'Leerling plaatst de IJssel in Nijmegen in plaats van de Waal.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-maas-als-langste',
  label: 'Denkt Maas is langste',
  module: 'Topo',
  description: 'Leerling denkt dat de Maas de langste rivier van Nederland is.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-waal-als-zelfstandige-rivier',
  label: 'Ziet Waal als zelfstandige rivier',
  module: 'Topo',
  description: 'Leerling ziet de Waal als een aparte rivier in plaats van een tak van de Rijn.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-ijssel-als-langste',
  label: 'Denkt IJssel is langste',
  module: 'Topo',
  description: 'Leerling denkt dat de IJssel de langste rivier van Nederland is.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-waddenzee-als-hoofdzee',
  label: 'Verwart Waddenzee met Noordzee',
  module: 'Topo',
  description: 'Leerling verwart de Waddenzee met de Noordzee als hoofdzee.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-oostzee-misplaatst',
  label: 'Plaatst Oostzee bij NL',
  module: 'Topo',
  description: 'Leerling plaatst de Oostzee bij Nederland in plaats van Scandinavië.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-rijn-als-noord-tak',
  label: 'Noemt Rijn i.p.v. noord-tak',
  module: 'Topo',
  description: 'Leerling noemt de Rijn in plaats van de specifieke noord-tak (IJssel).',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-maas-in-overijssel',
  label: 'Plaatst Maas in Overijssel',
  module: 'Topo',
  description: 'Leerling plaatst de Maas in Overijssel in plaats van het zuiden.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-waal-naar-ijsselmeer',
  label: 'Stuurt Waal naar IJsselmeer',
  module: 'Topo',
  description: 'Leerling denkt dat de Waal naar het IJsselmeer stroomt.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-deltawerken-als-afsluitdijk',
  label: 'Verwart Deltawerken met Afsluitdijk',
  module: 'Topo',
  description: 'Leerling verwart de Deltawerken in Zeeland met de Afsluitdijk.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-houtribdijk-als-afsluit',
  label: 'Verwart Houtribdijk met Afsluitdijk',
  module: 'Topo',
  description: 'Leerling verwart de Houtribdijk met de Afsluitdijk.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-oosterscheldekering-als-afsluit',
  label: 'Verwart stormvloedkering met Afsluitdijk',
  module: 'Topo',
  description: 'Leerling verwart de Oosterscheldekering met de Afsluitdijk.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-maas-met-rijn-bron-verward',
  label: 'Verwart Maas-bron met Rijn-bron',
  module: 'Topo',
  description: 'Leerling denkt dat de Maas uit Duitsland komt (zoals de Rijn).',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-bron-met-binnenkomst-verward',
  label: 'Verwart bronland met binnenkomstland',
  module: 'Topo',
  description: 'Leerling geeft het land waar de rivier ontspringt in plaats van waar hij Nederland binnenkomt.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-geografie-afstand-misgeschat',
  label: 'Mist geografische afstand',
  module: 'Topo',
  description: 'Leerling schat de geografische afstand verkeerd in (bijv. Spanje als buurland).',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-maas-als-rijn-tak',
  label: 'Ziet Maas als Rijn-tak',
  module: 'Topo',
  description: 'Leerling denkt dat de Maas een tak van de Rijn is.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-schelde-als-rijn-tak',
  label: 'Ziet Schelde als Rijn-tak',
  module: 'Topo',
  description: 'Leerling denkt dat de Schelde een tak van de Rijn is.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-eems-als-rijn-tak',
  label: 'Ziet Eems als Rijn-tak',
  module: 'Topo',
  description: 'Leerling denkt dat de Eems een tak van de Rijn is.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-rijn-in-rotterdam',
  label: 'Noemt Rijn i.p.v. Nieuwe Maas',
  module: 'Topo',
  description: 'Leerling noemt de Rijn in Rotterdam in plaats van de lokale naam Nieuwe Maas.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-waal-in-rotterdam',
  label: 'Plaatst Waal in Rotterdam',
  module: 'Topo',
  description: 'Leerling plaatst de Waal in Rotterdam in plaats van Nijmegen.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-ijssel-in-rotterdam',
  label: 'Plaatst IJssel in Rotterdam',
  module: 'Topo',
  description: 'Leerling plaatst de IJssel in Rotterdam in plaats van het oosten.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-adam-rijnkanaal-verward',
  label: 'Verwart Amsterdam-Rijnkanaal met zee-verbinding',
  module: 'Topo',
  description: 'Leerling verwart het binnenkanaal met de verbinding naar de Noordzee.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-nieuwe-waterweg-adam',
  label: 'Verwart Rotterdamse zee-verbinding met Amsterdamse',
  module: 'Topo',
  description: 'Leerling verwart de Nieuwe Waterweg (Rotterdam) met het Noordzeekanaal (Amsterdam).',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-markermeer-als-kanaal',
  label: 'Verwart meer met kanaal',
  module: 'Topo',
  description: 'Leerling verwart een meer met een kanaal.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-rijn-door-adam',
  label: 'Plaatst Rijn door Amsterdam',
  module: 'Topo',
  description: 'Leerling denkt dat de Rijn door Amsterdam stroomt.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-vecht-door-adam',
  label: 'Verwart Vecht met Amstel',
  module: 'Topo',
  description: 'Leerling verwart de Vecht met de Amstel in Amsterdam.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-zaan-door-adam',
  label: 'Verwart Zaan met Amstel',
  module: 'Topo',
  description: 'Leerling verwart de Zaan met de Amstel in Amsterdam.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-ooster-als-antwerpen-route',
  label: 'Verwart Oosterschelde met Westerschelde',
  module: 'Topo',
  description: 'Leerling denkt dat de Oosterschelde de route naar Antwerpen is.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-grevelingen-als-route',
  label: 'Verwart afgesloten meer met open zeearm',
  module: 'Topo',
  description: 'Leerling denkt dat het Grevelingenmeer de route naar Antwerpen is.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-haringvliet-als-route',
  label: 'Plaatst Antwerpen-route in Zuid-Holland',
  module: 'Topo',
  description: 'Leerling denkt dat het Haringvliet de route naar Antwerpen is.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-wester-als-kering',
  label: 'Verwart open Westerschelde met afsluitbare Oosterschelde',
  module: 'Topo',
  description: 'Leerling denkt dat de stormvloedkering in de Westerschelde ligt.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-hollands-diep-als-kering',
  label: 'Plaatst Deltakering te ver landinwaarts',
  module: 'Topo',
  description: 'Leerling denkt dat de stormvloedkering in het Hollands Diep ligt.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-markermeer-als-kering',
  label: 'Plaatst Zeeuwse kering in Flevoland',
  module: 'Topo',
  description: 'Leerling denkt dat de stormvloedkering in het Markermeer ligt.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-ijsselmeer-in-zuid',
  label: 'Plaatst IJsselmeer in zuiden',
  module: 'Topo',
  description: 'Leerling plaatst het IJsselmeer in het zuiden van Nederland.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-waddenzee-in-zuid',
  label: 'Plaatst Waddenzee in zuiden',
  module: 'Topo',
  description: 'Leerling plaatst de Waddenzee in het zuiden van Nederland.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-veluwemeer-in-zuid',
  label: 'Plaatst Veluwemeer in zuiden',
  module: 'Topo',
  description: 'Leerling plaatst het Veluwemeer in het zuiden van Nederland.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-noordzeekanaal-rotterdam',
  label: 'Verwart Amsterdamse zee-verbinding met Rotterdamse',
  module: 'Topo',
  description: 'Leerling denkt dat het Noordzeekanaal bij Rotterdam ligt.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-adam-rijnkanaal-rotterdam',
  label: 'Verwart binnenkanaal met zee-verbinding',
  module: 'Topo',
  description: 'Leerling denkt dat het Amsterdam-Rijnkanaal de zee-verbinding van Rotterdam is.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-westerschelde-rotterdam',
  label: 'Verwart Zeeuwse zeearm met Rotterdamse waterweg',
  module: 'Topo',
  description: 'Leerling denkt dat de Westerschelde de zee-verbinding van Rotterdam is.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-ijsselmeer-als-markermeer',
  label: 'Verwart IJsselmeer met Markermeer',
  module: 'Topo',
  description: 'Leerling verwart het noordelijke IJsselmeer met het zuidelijke Markermeer.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-veluwemeer-als-markermeer',
  label: 'Verwart oost-randmeer met west-randmeer',
  module: 'Topo',
  description: 'Leerling verwart het Veluwemeer met het Markermeer.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-grevelingen-als-markermeer',
  label: 'Plaatst Zeeuws meer bij Flevoland',
  module: 'Topo',
  description: 'Leerling verwart het Grevelingenmeer met het Markermeer.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-markermeer-als-veluwemeer',
  label: 'Verwart west-randmeer met oost-randmeer',
  module: 'Topo',
  description: 'Leerling verwart het Markermeer met het Veluwemeer.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-ijsselmeer-als-veluwemeer',
  label: 'Verwart groot meer met klein randmeer',
  module: 'Topo',
  description: 'Leerling verwart het IJsselmeer met het Veluwemeer.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-hollandsdiep-als-veluwemeer',
  label: 'Plaatst zuid-water bij Flevoland',
  module: 'Topo',
  description: 'Leerling verwart het Hollands Diep met het Veluwemeer.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-maas-als-nederrijn-voortzetting',
  label: 'Verwart Maas met Nederrijn-voortzetting',
  module: 'Topo',
  description: 'Leerling denkt dat de Maas de voortzetting van de Nederrijn is.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-ijssel-als-lek',
  label: 'Verwart noord-tak met west-tak',
  module: 'Topo',
  description: 'Leerling verwart de IJssel met de Lek.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-dommel-als-lek',
  label: 'Verwart Brabants riviertje met grote Rijn-tak',
  module: 'Topo',
  description: 'Leerling verwart de Dommel met de Lek.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-maas-in-eindhoven',
  label: 'Plaatst Maas in Eindhoven',
  module: 'Topo',
  description: 'Leerling denkt dat de Maas door Eindhoven stroomt.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-vecht-in-brabant',
  label: 'Verwart Vecht met Dommel',
  module: 'Topo',
  description: 'Leerling denkt dat de Vecht door Brabant stroomt.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-amstel-in-brabant',
  label: 'Verwart Amstel met Dommel',
  module: 'Topo',
  description: 'Leerling denkt dat de Amstel door Brabant stroomt.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-markermeer-als-zoutwater',
  label: 'Verwart zoetwatermeer met zoutwatermeer',
  module: 'Topo',
  description: 'Leerling denkt dat het Markermeer zout water is.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-veluwemeer-als-zoutwater',
  label: 'Verwart oost-randmeer met zuidwest-meer',
  module: 'Topo',
  description: 'Leerling denkt dat het Veluwemeer zout water is.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-waddenzee-als-meer',
  label: 'Verwart open zee met afgesloten meer',
  module: 'Topo',
  description: 'Leerling denkt dat de Waddenzee een afgesloten meer is.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-ijssel-als-vecht',
  label: 'Verwart twee Overijsselse rivieren',
  module: 'Topo',
  description: 'Leerling verwart de IJssel met de Vecht.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-eems-in-overijssel',
  label: 'Plaatst Eems in Overijssel',
  module: 'Topo',
  description: 'Leerling plaatst de Eems in Overijssel in plaats van Groningen.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-rijn-in-overijssel',
  label: 'Plaatst Rijn in Overijssel',
  module: 'Topo',
  description: 'Leerling plaatst de Rijn in Overijssel in plaats van Gelderland.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-eb-als-overstroming',
  label: 'Verwart eb met overstroming',
  module: 'Topo',
  description: 'Leerling denkt dat eb een overstroming betekent.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-eb-als-vorst',
  label: 'Verwart getij met temperatuur',
  module: 'Topo',
  description: 'Leerling denkt dat eb met bevriezen te maken heeft.',
  typicalFamilies: ['TOPO-NL-WATER']
}, {
  id: 'topo.water-eb-als-verzoeting',
  label: 'Verwart getij met zoutgehalte',
  module: 'Topo',
  description: 'Leerling denkt dat eb het water zoet maakt.',
  typicalFamilies: ['TOPO-NL-WATER']
}];